import classNames from 'classnames';
import { styled } from '@mui/material/styles';
import { useCallback } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { IBoxComponent, IBoxTextareaComponent } from '@enuan/chat__utils';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';
import { FormRow } from './FormRow';

type ITextareaProps = IBoxComponent<
	IBoxTextareaComponent<
		Omit<React.ComponentProps<typeof TextareaAutosize>, 'ref'>
	>
> & {
	box?: boolean;
	onChange?: (value: string | undefined) => void;
};

export const TextareaBox = styled(
	({
		// custom props
		type,
		help_label,
		error,
		error_label,
		label,
		onChange,
		box,

		// standard props
		id, //ignore it to avoid duplicate
		value = '',
		className,
		required,
		..._props
	}: ITextareaProps) => {
		const props = cleanBoxProps(_props);

		const _onChange = useCallback(
			(e: React.FormEvent<HTMLTextAreaElement>) => {
				const value = e.currentTarget.value;
				onChange?.(value);
			},
			[onChange],
		);

		return (
			<FormRow
				className={classNames('form__row--textarea', className)}
				label={label}
				error={error}
				error_label={error_label}
				help_label={help_label}
				required={required}
			>
				<TextareaAutosize
					onChange={_onChange}
					className={classNames(
						'textarea',
						'input',
						!!error && 'input--error',
						box && 'textarea--box',
						!!value && `input--compiled`,
					)}
					rows={box ? 3 : undefined}
					value={value}
					required={required}
					{...props}
				/>
			</FormRow>
		);
	},
	{
		label: 'Textarea',
		target: 'Textarea-root',
	},
)({
	'& .textarea': {
		resize: 'none',
	},
	'& .textarea--box': {
		backgroundColor: 'var(--form__textarea_background)',
		borderBottom: 0,
		padding: '0.8em',
		borderRadius: '0.4em',
		color: 'var(--form__textarea_color)',
		'&::placeholder': {
			color: 'var(--form__textarea__placeholder_color)',
		},
	},
});
